import { Clock, ShieldAlert, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LogoMark } from "@/components/logo/AetriaLogo";

const VARIANTS = {
  tenant_pending: {
    icon: Clock, color: "text-amber-500",
    titleKey: "suspended.pendingTitleRequest", fallbackKey: "suspended.pendingMsgRequest",
    testid: "pending",
  },
  tenant_rejected: {
    icon: XCircle, color: "text-red-500",
    titleKey: "suspended.rejectedTitleRequest", fallbackKey: "suspended.rejectedMsgRequest",
    testid: "rejected",
  },
  tenant_suspended: {
    icon: ShieldAlert, color: "text-amber-500",
    titleKey: "suspended.suspendedTitle", fallbackKey: "suspended.suspendedMsg",
    testid: "suspended",
  },
};

function readBlock() {
  try {
    return JSON.parse(sessionStorage.getItem("aetria_block") || "null");
  } catch {
    return null;
  }
}

export default function SuspendedPage() {
  const { t } = useTranslation();
  const block = readBlock();
  const variant = VARIANTS[block?.code] || VARIANTS.tenant_suspended;
  const Icon = variant.icon;
  const message = block?.detail || t(variant.fallbackKey);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="suspended-screen">
      <div className="max-w-md w-full bg-white border border-slate-200 p-10 text-center">
        <div className="flex justify-center mb-6"><LogoMark size={44} /></div>
        <div className="flex justify-center mb-4">
          <Icon className={`h-10 w-10 ${variant.color}`} />
        </div>
        <h1 className="text-xl font-bold text-[var(--brand-primary)] tracking-tight"
          data-testid="suspended-title" data-variant={variant.testid}>
          {t(variant.titleKey)}
        </h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed" data-testid="suspended-message">
          {message}
        </p>
        <button
          data-testid="suspended-back-btn"
          onClick={() => {
            localStorage.removeItem("aetria_token");
            sessionStorage.removeItem("aetria_block");
            window.location.href = "/login";
          }}
          className="mt-8 text-[11px] font-semibold uppercase tracking-[0.12em] text-teal-700 hover:text-teal-800"
        >
          {t("suspended.backToSignIn")}
        </button>
      </div>
    </div>
  );
}
